import Badge from "./Badge";
import Separator from "./Separator";
import video from "../assets/hero/video.mp4";

const Profesional = () => {
  return (
    <section className="h-[80vh] xl:h-screen relative text-white">
        <div className="bg-hero_overlay opacity-45 absolute w-full h-full z-10 bg-primary/[0.01]"></div>
        <video 
            autoPlay 
            loop 
            muted 
            className="absolute top-0 left-0 w-full h-full object-cover"
        >
            <source src={video} type="video/mp4" />
            Tu navegador no soporta el tag de video.
        </video>
        <div className="container mx-auto h-full flex flex-col xl:flex-row items-center z-30 relative">
            <div data-scroll data-scroll-speed="0.4" className="flex-1 flex flex-col text-center justify-center items-center xl:pb-12 gap-10 h-full">
                <div className="flex flex-col items-center pt-16 md:pt-9">
                    <Badge containerStyles="hidden xl:flex xl:w-[180px] xl:h-[140px]" />
                    <h1 className="h1 text-4xl lg:text-6xl text-white">
                        <span className="text-white">SERVICIOS DE BUCEO PROFESIONAL</span>
                    </h1>
                </div>                
                <Separator />
                <p>En Frogman, ofrecemos servicios de buceo profesional de alta calidad, respaldados por años de experiencia y un compromiso inquebrantable con la seguridad. Nuestro equipo de buzos altamente cualificados está preparado para realizar una amplia gama de tareas subacuáticas, desde inspecciones y mantenimiento hasta rescates y filmaciones. Utilizamos equipos de última generación para garantizar precisión y eficiencia en cada proyecto, asegurando siempre la máxima seguridad y satisfacción de nuestros clientes.</p>
            </div>
        </div>
    </section>
  )
}

export default Profesional